var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('cards',{attrs:{"cardsTit":"报警数量","cardsNum":300}},[_c('template',{slot:"cardsConter"},[_c('div',{ref:"chart1",staticStyle:{"width":"100%","height":"100%"}})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }